// Pure role model shared by the route guards, the navigation config and the reports drawer.
// Keep this file free of React/DOM imports so node:test can load it (see tests/unit/roles.test.mjs).

export const ROLES_LABELS = {
    OWNER: 'owner',
    ADMIN: 'admin',
    EDITOR: 'editor',
    VIEWER: 'viewer',
    READER: 'reader',
    PROMOTER: 'promoter',
    SCANNER: 'scanner',
    CASHIER: 'cashier',
    USER: 'user'
}

export const RolesMap = {
    owner: { label: ROLES_LABELS.OWNER, weight: 100 },
    admin: { label: ROLES_LABELS.ADMIN, weight: 80 },
    editor: { label: ROLES_LABELS.EDITOR, weight: 40 },
    cashier: { label: ROLES_LABELS.CASHIER, weight: 40 },
    viewer: { label: ROLES_LABELS.VIEWER, weight: 30 }, // one of them irrelevant
    trainer: { label: ROLES_LABELS.VIEWER, weight: 30 },
    reader: { label: ROLES_LABELS.READER, weight: 30 }, // one of them irrelevant
    promoter: { label: ROLES_LABELS.PROMOTER, weight: 20 },
    scanner: { label: ROLES_LABELS.SCANNER, weight: 20 },
    user: { label: ROLES_LABELS.USER, weight: 1 }
}

/** The minimum role that can open the cashier page (route + nav item). Single source for the "who can sell" rule. */
export const CASHIER_PAGE_MIN_ROLE = ROLES_LABELS.READER

/** Same predicate as RoleGuard's userAllowToAccess: plain users and unknown roles never pass. */
export const roleMeetsMinimum = (role, minimumRole) => {
    if (!role || role === ROLES_LABELS.USER) return false
    const userWeight = RolesMap[role]?.weight
    const minWeight = RolesMap[minimumRole]?.weight
    if (userWeight === undefined || minWeight === undefined) return false
    return userWeight >= minWeight
}

/** Whoever can open the cashier page can complete a sale there and be stamped as its seller (#1573). */
export const canSellAtCounter = (role) => roleMeetsMinimum(role, CASHIER_PAGE_MIN_ROLE)

/** Keeps only the collaborators whose role can sell at the counter. */
export const filterSellingCollaborators = (collaborators) => (collaborators || []).filter((c) => canSellAtCounter(c?.role))
